// AddOns.js
const { Autodesk } = window;

class AddOns extends Autodesk.Viewing.Extension {
    constructor(viewer, options) {
        super(viewer, options);
        this.viewer = viewer;
        this.button1 = null;
        this.button2 = null;
        /** @type {(event: Autodesk.Viewing.SelectionChangedEvent) => void} */
        this._onSelectionChanged = null;
    }

    load() {
        console.log("AddOns extension loaded");
        this.createButtons();
        return true;
    }

    unload() {
        console.log("AddOns extension unloaded");
        if (this.controlGroup) {
            // Remove control group explicitly correctly
            this.viewer.toolbar.removeControl(this.controlGroup);
            this.controlGroup = null;
            this.button1 = null;
            this.button2 = null;
        }
        if (this._onSelectionChanged) {
            this.viewer.removeEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, this._onSelectionChanged);
            this._onSelectionChanged = null;
        }
        return true;
    }


    createButtons() {
        // Create a new button.
        this.button1 = new Autodesk.Viewing.UI.Button("addOnsButton1");
        this.button1.addClass('bi');
        this.button1.addClass('bi-toggle-off');
        this.button1.setToolTip("AddOns Button 1");
        // Set initial state to INACTIVE.
        this.button1.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);

        // Toggle state on click.
        this.button1.onClick = () => {
            if (this.button1.getState() === Autodesk.Viewing.UI.Button.State.INACTIVE) {
                this.button1.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);
                console.log("AddOns Button 1  activated");
                this.enableSelectionLogging();
            } else {
                this.button1.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
                console.log("AddOns Button 1 deactivated");
                this.disableSelectionLogging();
            }
        };

        this.button2 = new Autodesk.Viewing.UI.Button("addOnsButton2");
        this.button2.addClass('bi');
        this.button2.addClass('bi-chat-left-text');
        this.button2.setToolTip("AddOns Button 2");

        this.button2.onClick = () => {
            if (this.button2.getState() === Autodesk.Viewing.UI.Button.State.INACTIVE) {
                this.button2.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);
                console.log("AddOns Button 2  activated");
            } else {
                this.button2.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
                console.log("AddOns Button 2 deactivated");
            }
        };

        // Create a control group and add the button to it.
        const controlGroup = new Autodesk.Viewing.UI.ControlGroup("addOnsControlGroup");
        controlGroup.addControl(this.button1);
        controlGroup.addControl(this.button2);
        // Add the control group to the viewer toolbar.
        this.viewer.toolbar.addControl(controlGroup);
    }

    /** Enable logging of selected object data */
    enableSelectionLogging() {
        if (this._onSelectionChanged) return;
        this._onSelectionChanged = async (event) => {
            if (event.dbIdArray && event.dbIdArray.length > 0) {
                const data = await this.getNodeDataRecursive(event.dbIdArray[0]);
                console.log("Selected object data:", JSON.stringify(data, null, 2));
            }
        };
        this.viewer.addEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, this._onSelectionChanged);

        // Immediately log current selection if any
        const current = this.viewer.getSelection();
        if (current && current.length > 0) {
            this._onSelectionChanged({ dbIdArray: current });
        }
    }

    /** Disable logging of selected object data */
    disableSelectionLogging() {
        if (this._onSelectionChanged) {
            this.viewer.removeEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, this._onSelectionChanged);
            this._onSelectionChanged = null;
        }
    }

    /**
     * Recursively gather object data for specified dbId.
     * @param {number} dbId
     * @returns {Promise<object>}
     */
    async getNodeDataRecursive(dbId) {
        const props = await new Promise((resolve, reject) => {
            this.viewer.getProperties(dbId, resolve, reject);
        });

        const tree = this.viewer.model.getInstanceTree();
        const childIds = [];
        if (tree) {
            tree.enumNodeChildren(dbId, (childId) => childIds.push(childId));
        }

        const children = [];
        for (const childId of childIds) {
            children.push(await this.getNodeDataRecursive(childId));
        }

        return {
            dbId: props.dbId,
            name: props.name,
            externalId: props.externalId,
            properties: props.properties,
            children
        };
    }
}

Autodesk.Viewing.theExtensionManager.registerExtension("AddOns", AddOns);
window.MyExtension = AddOns;
